import { useEffect, useState } from "react";

import Moment from "moment";
import PropTypes from "prop-types";

import {
  autosaveMessageCss,
  editingAreaCss,
  fieldsetCss,
  headingCss,
  questionTextCss,
} from "./StudentWriteResponseForm.style";

const propTypes = {
  classroomName: PropTypes.string,
  currentWritePrompt: PropTypes.shape({
    grade_band: PropTypes.string,
    id: PropTypes.string,
    is_active: PropTypes.bool,
    language: PropTypes.string,
    questions: PropTypes.arrayOf(Object),
  }),
  handleChange: PropTypes.func,
  isAutoSaving: PropTypes.bool,
  mostRecentSave: PropTypes.instanceOf(Moment),
  submitStudentWriteResponse: PropTypes.func,
  writePromptResponseText: PropTypes.string,
  isSubmittedAndReviewed: PropTypes.bool,
};

const ONE_MINUTE = 60000;

const StudentWriteResponseForm = ({
  classroomName,
  currentWritePrompt,
  handleChange,
  isAutoSaving,
  mostRecentSave,
  writePromptResponseText,
  isSubmittedAndReviewed,
}) => {
  const [timeElapsedSinceSave, setTimeElapsedSinceSave] = useState(null);

  useEffect(() => {
    setTimeElapsedSinceSave(mostRecentSave?.fromNow());
    const interval = setInterval(() => {
      setTimeElapsedSinceSave(mostRecentSave?.fromNow());
    }, ONE_MINUTE);

    return () => clearInterval(interval);
  }, [mostRecentSave]);

  const renderQuestionText = () => {
    const htmlQuestion = currentWritePrompt?.questions?.[0]?.html_question;
    const question = currentWritePrompt?.questions?.[0]?.question;

    return !htmlQuestion && !question
      ? ""
      : currentWritePrompt?.questions?.[0]?.html_question ||
          currentWritePrompt?.questions?.[0]?.question;
  };

  return (
    <>
      {!isSubmittedAndReviewed && <h3 css={headingCss}>{classroomName}</h3>}
      <form role="form" aria-labelledby="submitWritePromptResponse">
        <fieldset css={fieldsetCss}>
          {!isSubmittedAndReviewed && (
            <legend
              css={questionTextCss}
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: renderQuestionText() }}
            />
          )}
          <label css={headingCss} htmlFor="textarea_reponse">
            {!isSubmittedAndReviewed ? "Response" : "New response"}
          </label>
          <textarea
            id="textarea_reponse"
            css={editingAreaCss}
            placeholder="Start typing..."
            rows={7}
            value={writePromptResponseText}
            onChange={(e) => {
              handleChange(e.target.value);
            }}
          />
        </fieldset>
      </form>
      {!isAutoSaving && timeElapsedSinceSave && (
        <p css={autosaveMessageCss} role="alert">
          Draft saved {timeElapsedSinceSave}
        </p>
      )}
    </>
  );
};

StudentWriteResponseForm.propTypes = propTypes;

export default StudentWriteResponseForm;
